import { observer } from 'mobx-react-lite';
import type { ApplicationSdk } from './core/sdk';
import { DocumentView } from './features/signabledocuments';
import { BaseLayout } from './PortalView';

export const PublicView = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    return (
        <BaseLayout
            sdk={sdk}
            showPoweredBy={false}
        >
            {sdk.locationPublicUrl?.startsWith('/signabledocuments/') ? (
                <DocumentView sdk={sdk} />
            ) : null}
        </BaseLayout>
    );
});
